module.exports = __webpack_public_path__ + "static/media/logoVisnu.2400059e.png";